var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Echart',{attrs:{"options":_vm.options,"id":"living-index","height":"280px","width":"280px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }